/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { ResponsiveContext } from 'src/core/utils/contexts/ResponsiveContext';
import { ResponsiveModeProps, withResponsiveMode } from 'src/core/utils/hocs/withResponsive';

export type ResponsiveProviderProps = {
    /**
     * Children to be rendered.
     */
    children: React.ReactNode;
} & ResponsiveModeProps;

/**
 * Provider component that subscribes to the office fabric's responsive HOC and provides the value
 * in a context that could be consumed later.
 * Note: React complains if this component is function with something regarding passing refs.
 */
class ResponsiveProviderBase extends React.Component<ResponsiveProviderProps> {
    /**
     * Renders the repsonsive provider conext.
     */
    public render(): React.ReactNode {
        return <ResponsiveContext.Provider value={this.props.responsiveMode}>{this.props.children}</ResponsiveContext.Provider>;
    }
}

export const ResponsiveProvider = withResponsiveMode(ResponsiveProviderBase);
